import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderBaseComponent } from '@technocom/core';
import { SYSTEM_LANGUAGES } from '../../../../../assets/i18n';
import { TranslocoService } from '@ngneat/transloco';
import { SecurityService } from '@technocom/auth';
import { Role } from '@app/shared/models/user/role';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent extends HeaderBaseComponent {
  constructor(private localeService: TranslocoService, private securityService: SecurityService) {
    super();
  }

  languages = Object.keys(SYSTEM_LANGUAGES);
  selectedLang = 'ru';

  valueChange(e) {
    if (e !== this.localeService.getActiveLang()) this.localeService.setActiveLang(e);
  }

  get isPublic(): boolean {
    return !this.securityService.canUserAccess([Role.OPR, Role.DATA_ADM]);
  }
}
